import { css } from "styled-components";

export const surveyListMode = (props) => css`
  border-radius: 8px;
  padding: 0;
  > .collapsibleWrapper {
    border-bottom: 1px solid
      ${props.openAlternatives ? props.theme.colors.details : "transparent"};
    padding-left: 18px;
    height: 74px;
    .select {
      width: 70px;
      height: 74px;
    }
  }
  div > .collapsibleBody {
    border: none;
    margin: 0px 13px 10px;
  }
  .titles .label {
    border: none;
    font-size: 14px;
    padding: 0;
    color: ${props.theme.collapsibleList.textColor};
  }
  .titles h2 {
    font-size: 17.2612px;
    color: ${props.theme.colors.text.default};
  }
  :hover {
    .collapsibleWrapper {
      border-color: ${props.openAlternatives
    ? props.theme.colors.secondary
    : "transparent"};
      .select {
        border-color: ${props.theme.colors.secondary};
        svg path {
          fill: ${props.theme.colors.text.default};
        }
      }
    }
  }
`

export const questionListMode = (props) => css`
  display: flex;
  background-color: ${props.theme.colors.cardContainerEvolutiveCross};
  max-height: 53px;
  min-height: 53px;
  padding: 0;
  border: none;
  > .collapsibleWrapper {
    border: none;
    padding-left: 18px;
    margin-bottom: 0;

    > div {
      width: calc(100% - 56px);

      > .titles {
        width: calc(100% - 40px);
      }
    }
    
    .select {
      height: 53px;
      border: none;
      svg path {
        fill: ${props.isChecked
    ? props.theme.colors.borderHoverCollapsibleContainer
    : props.theme.colors.secondary};
      }
    }

    .titles div h2 {
      line-height: 18px;
      padding-top: 0;
    }
  }
  div > .collapsibleBody {
    margin: -2px 0 0 !important;
    padding: 0;
    border-radius: 0 0 4px 4px;
    width: 100%;
    background-color: ${props.isChecked
    ? props.theme.colors.backgroundItemColor
    : props.theme.colors.cardContainerEvolutiveCross};
  }
  :hover {
    background-color: ${props.theme.colors.cardContainerEvolutiveCross};
    border: none;
    .select {
      svg path {
        fill: ${props.isChecked
    ? props.theme.colors.borderHoverCollapsibleContainer
    : props.theme.colors.secondary} !important;
      }
    }
  }
`

export const combinedListMode = (props) => css`
  background-color: ${props.theme.colors.cardContainerEvolutiveCross};
  min-height: 54px;
  max-height: ${props.openAlternatives ? "auto" : "54px"};
  margin-bottom: 6px;
  width: calc(100% - 40px);

  > .collapsibleWrapper {
    .titles {
      justify-content: center;
      width: ${!props.expansible ? "100%" : ""};
      margin: 0;

      .label {
        border: 1px solid ${props.theme.colors.text.default};
        color: ${props.theme.colors.text.default};
      }

      h2 {
        padding: 0;
        width: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal;
      }
    }
    .select {
      height: 42px;
      border-left: 1px solid ${props.theme.colors.text.placeholder};

      &:hover {
        svg {
          fill: ${props.theme.colors.text.secondary};
        }
  
        svg path {
          fill: ${props.theme.colors.text.secondary};
        }
      }
    }
  }

  &:hover {
    background-color: ${props.theme.colors.EvolutivevOkButtonColor};

    > .collapsibleWrapper {
      .select {
        border-left: 1px solid ${props.theme.colors.secondary};
      }
    }
  }
`

export const sendModalCombination = (props) => css`
  max-height: 36px;
  min-height: 36px;
  background-color: ${props.theme.colors.cardContainerEvolutiveCross};
  padding: 8px 4px 8px 20px;

  > .collapsibleWrapper {
    span.checkbox {
      border: solid 1px ${props.theme.colors.text.default};
    }

    .titles {
      max-width: calc(100% - 200px);
      margin-left: 10px;

      h2 {
        padding: 0;
      }
    }
  }

  .rightContent {
    display: flex;
    align-items: center;
    margin: 0;
    gap: 8px;
    
    color: ${props.theme.colors.secondary};

    padding: 0 28px 0 0;
    max-width: 200px;
    width: 100%;
    justify-content: flex-end;

    .icon {
      margin: 0;
      fill: transparent;
      stroke: ${props.theme.colors.secondary};
    }
  }

  ${props.isChecked
    ? css`
        background-color: ${props.theme.colors.backgroundItemColor};

        .rightContent {
          color: ${props.theme.colors.text.default};

          .icon {
            stroke: ${props.theme.colors.text.default};
          }
        }
      `
    : ''
  }

  &:hover {
    background-color: ${props.theme.colors.backgroundItemColor};
    border: 1px solid transparent;
  }
`

export const stepThreeCombinedAlternatives = (props) => css`
  max-height: 36px;
  min-height: 36px;
  background-color: ${props.theme.colors.highLight};;
  padding: 8px 4px 8px 10px;

  > .collapsibleWrapper {
    .titles {
      max-width: calc(100% - 200px);
      margin-left: 10px;

      h2 {
        padding: 0;
      }
    }
  }

  .rightContent {
    display: flex;
    align-items: center;
    margin: 0;
    gap: 8px;
    
    color: ${props.theme.colors.secondary};

    padding: 0 28px 0 0;
    max-width: 200px;
    width: 100%;
    justify-content: flex-end;

    .icon {
      margin: 0;
      fill: transparent;
      stroke: ${props.theme.colors.secondary};

      path {
        fill: transparent;
      }
    }
  }

  &:hover {
    border: 1px solid ${props.theme.colors.secondary};
  }
`

export const stepThreeList = (props) => css`
  padding: 16px 0 16px 10px;

  > .collapsibleWrapper {
    .titles {
      gap: 18px;
      
      > div {
        gap: 8px;

        svg.iconTitle {
          width: 20px;
          height: 20px;
          fill:  ${props.theme.colors.text.default};
        }
      }

      h2 {
        font-size: 16px;
        line-height: 19px;
        width: 100%;
        padding: 0;
      }
    }

    .select {
      width: 75px;
      height: 42px;
      border-left: 1px solid transparent;

      svg {
        fill: ${props.theme.colors.secondary};
      }

      svg path {
        fill: ${props.theme.colors.secondary};
      }
    }

    & + div {
      padding: 0 29px 0 19px;
  
      > .collapsibleBody {
        margin-top: 19px;
        padding: 18px 0 0 0;
  
        > div {
          margin: 0;
          gap: 18px;
  
          p {
            display: flex;
            align-items: center;
            gap: 8px;

            font-weight: 700;
            font-size: 16px;
            line-height: 19px;
            color: solid 1px ${props.theme.colors.constrat};

            svg path {
              fill: transparent;
            }
          }
        }
      }
    }
  }
`

export const stepThreeSeparateAlternatives = (props) => css`
  min-height: 67px;
  max-height: 67px;
  padding: 0 20px;

  > .collapsibleWrapper {
    justify-content: flex-start;
    align-items: flex-end;

    .titles {
      gap: 10px;
      margin-left: 8px;
      
      > .label {
        gap: 8px;
        margin-left: -30px;

        svg.iconTitle {
          width: 20px;
          height: 20px;
          fill:  ${props.theme.colors.text.default};
        }
      }

      h2 {
        font-size: 16px;
        line-height: 19px;
        width: 100%;
        padding: 0;
      }
    }

    .select {
      display: none;
    }
  }
`
